var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisableTotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#D7D7D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4438_46527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7766 16.709L15.8936 8.71422C15.6696 8.25293 15.1137 8.06048 14.6522 8.28454L10.5547 10.2748L14.4574 18.3107C14.84 18.3782 15.1957 18.5466 15.489 18.803C15.7043 18.9911 15.8769 19.2175 16.0024 19.4756C16.0153 19.5026 16.0264 19.53 16.0383 19.5571L19.3467 17.9503C19.8082 17.7262 20.0006 17.1706 19.7766 16.709Z",
    fill: "#6B6B6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1373 19.2058C14.9028 19.0009 14.6158 18.871 14.3122 18.8275C14.0089 18.7841 13.6864 18.8281 13.3911 18.9719C13.1943 19.0674 13.0241 19.1996 12.8876 19.3558C12.6827 19.5902 12.5527 19.8774 12.5093 20.1811C12.4655 20.4843 12.5099 20.8066 12.6536 21.1021C12.7491 21.2987 12.8814 21.4689 13.0377 21.6055C13.2721 21.8104 13.5592 21.9403 13.8628 21.984C14.1661 22.0275 14.4885 21.9833 14.7838 21.8394C14.9805 21.7442 15.1507 21.6118 15.2872 21.4555C15.4921 21.2211 15.6221 20.934 15.6656 20.6305C15.7094 20.3271 15.6649 20.0047 15.5212 19.7093C15.4258 19.5126 15.2934 19.3424 15.1373 19.2058ZM14.5984 20.7024C14.5409 20.8012 14.457 20.8827 14.3456 20.937C14.2709 20.9732 14.195 20.9919 14.1186 20.996C14.0045 21.0019 13.8893 20.9738 13.7908 20.9166C13.6918 20.8591 13.6104 20.7753 13.5561 20.6638C13.5198 20.589 13.5013 20.5132 13.4973 20.4369C13.4912 20.3226 13.5192 20.2077 13.5764 20.1089C13.634 20.0101 13.7178 19.9286 13.8293 19.8742C13.904 19.838 13.98 19.8194 14.0562 19.8155C14.1704 19.8093 14.2856 19.8375 14.3843 19.8947C14.4831 19.9521 14.5646 20.036 14.6189 20.1474C14.6551 20.2223 14.6737 20.2983 14.6778 20.3746C14.6837 20.4887 14.6556 20.6038 14.5984 20.7024Z",
    fill: "#6B6B6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9479 18.2816L7.60048 5.21209C7.61265 5.18699 7.624 5.16111 7.63332 5.13397L7.68971 4.97124C7.81413 4.61166 7.62362 4.21893 7.2639 4.09451L7.10102 4.03812C6.74144 3.91363 6.34885 4.10404 6.2244 4.4639L6.16801 4.62688C6.04345 4.98625 6.23414 5.37866 6.59375 5.50336L6.75659 5.55975C6.80173 5.57554 6.84726 5.58587 6.89268 5.5921L13.1572 18.4907C13.4078 18.3689 13.6755 18.2993 13.9479 18.2816Z",
    fill: "#6B6B6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4438_46527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableTotes);
export default __webpack_public_path__ + "static/media/disable_totes.c0391f9295e990f343e6a3c069ae32d6.svg";
export { ForwardRef as ReactComponent };